export const initHeroMascot = () => {
  const mascot = document.querySelector('.hero__mascot');
  if (!mascot) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce.matches) return;

  const hero = mascot.closest('.hero');
  const desktop = window.matchMedia('(min-width: 992px)');

  const parallaxShift = 22;
  const parallaxRotate = 3;
  const ease = 0.08;

  const floatAmpX = 6;
  const floatAmpY = 11;
  const floatAmpRot = 1.2;

  let targetX = 0;
  let targetY = 0;
  let curX = 0;
  let curY = 0;
  let running = false;
  let raf = null;
  const start = performance.now();

  const render = (now) => {
    const t = (now - start) / 1000;
    const floatX = Math.sin(t * 0.6) * floatAmpX;
    const floatY = Math.sin(t * 0.9) * floatAmpY;
    const floatRot = Math.sin(t * 0.5) * floatAmpRot;

    curX += (targetX - curX) * ease;
    curY += (targetY - curY) * ease;

    const onDesktop = desktop.matches;
    const px = onDesktop ? curX * parallaxShift : 0;
    const py = onDesktop ? curY * parallaxShift : 0;
    const pr = onDesktop ? curX * parallaxRotate : 0;

    mascot.style.transform = `translate(${(px + floatX).toFixed(2)}px, ${(py + floatY).toFixed(2)}px) rotate(${(pr + floatRot).toFixed(3)}deg)`;

    if (running) raf = requestAnimationFrame(render);
  };

  const startLoop = () => {
    if (running) return;
    running = true;
    raf = requestAnimationFrame(render);
  };

  const stopLoop = () => {
    running = false;
    if (raf) cancelAnimationFrame(raf);
    raf = null;
  };

  window.addEventListener('mousemove', (event) => {
    if (!desktop.matches) return;
    targetX = event.clientX / window.innerWidth - 0.5;
    targetY = event.clientY / window.innerHeight - 0.5;
  });

  document.addEventListener('mouseleave', () => {
    targetX = 0;
    targetY = 0;
  });

  if (hero && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            startLoop();
          } else {
            stopLoop();
          }
        });
      },
      { threshold: 0 }
    );
    observer.observe(hero);
  } else {
    startLoop();
  }
};
